import { render } from "./Umrah_trips.vue?vue&type=template&id=24368aba&scoped=true"
import script from "./Umrah_trips.vue?vue&type=script&lang=js"
export * from "./Umrah_trips.vue?vue&type=script&lang=js"

import "./Umrah_trips.vue?vue&type=style&index=0&id=24368aba&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24368aba"]])

export default __exports__